import React, {useState} from 'react';
import {Box} from "@mui/material";
import useWindowWidth from "../hooks/useWindowWidth";
import LeftNavigationBar from "../components/navigation/LeftNavigationBar";
import TopNavigationBar from "../components/navigation/TopNavigationBar";
import ContentWrapper from "../components/wrapper/ContentWrapper";
import {Route, Routes, useLocation} from "react-router-dom";
import {Article, Badge, LocalShipping, Newspaper, Percent} from '@mui/icons-material';
import {Chip, Paper, Stack, Typography} from '@mui/material';
import BlogComponent from "../components/pages/BlogComponent";
import ProductComponent from "../components/pages/ProductComponent";
import PassportComponent from "../components/pages/PassportComponent";
import DocumentsComponent from "../components/pages/DocumentsComponent";
import PromoComponent from "../components/pages/PromoComponent";
import GenerateDocumentComponent from "../components/pages/GenerateDocumentComponent";
import OrderComponent from "../components/pages/OrderComponent";

export const leftNavBarWidth = 275;


const PanelPage: React.FC = () => {
    const location = useLocation();
    const [open, setOpen] = useState(false);
    const { isMobile } = useWindowWidth();

    const handleLeftNavBarOpen = () => {
        setOpen(true);
    };

    const handleLeftNavBarClose = () => {
        setOpen(false);
    };

    const section = location.pathname.includes('/blog')
        ? { label: 'Редакция', title: 'Блог', text: 'Публикации, категории материалов и изображения клиентского сайта.', icon: <Newspaper /> }
        : location.pathname.includes('/passport')
            ? { label: 'Проверка данных', title: 'Паспорта', text: 'Заявки пользователей и материалы для подтверждения личности.', icon: <Badge /> }
            : location.pathname.includes('/docs') && !location.pathname.includes('/docs-gen')
                ? { label: 'Юридический раздел', title: 'Документы', text: 'Актуальные политики и пользовательские документы проекта.', icon: <Article /> }
                : location.pathname.includes('/promo')
                    ? { label: 'Лояльность', title: 'Пользователи и промокоды', text: 'Выдача персональных предложений и контроль их использования.', icon: <Percent /> }
                    : location.pathname === '/admin/panel' || location.pathname === '/admin/panel/'
                        ? { label: 'Операционный центр', title: 'Заказы', text: 'Доставка, возвраты и жизненный цикл каждой аренды.', icon: <LocalShipping /> }
                        : null;

    return (
        <Box sx={{ display: 'flex' }}>
            <LeftNavigationBar width={leftNavBarWidth} open={open} onClose={handleLeftNavBarClose} isMobile={isMobile} />
            <Box component="main" id="main-content" sx={{ flexGrow: 1, width: `calc(100% - ${leftNavBarWidth}px)`, minHeight: '100dvh',
                overflow: 'hidden' }}>
                <TopNavigationBar drawerWidth={leftNavBarWidth} isMobile={isMobile} onDrawerOpen={handleLeftNavBarOpen} />
                <ContentWrapper>
                    {section && <Paper component="header" elevation={0} sx={{ mb: 3, p: { xs: 2.5, md: 3.5 }, borderRadius: 3,
                        color: 'white', bgcolor: 'primary.main', overflow: 'hidden', position: 'relative' }}>
                        <Stack direction="row" gap={2.5} alignItems="center" position="relative">
                            <Box sx={{ width: 52, height: 52, borderRadius: 2.5, display: 'grid', placeItems: 'center',
                                bgcolor: 'rgba(255,255,255,.12)', color: 'secondary.light', '& svg': { fontSize: 28 } }}>{section.icon}</Box>
                            <Box><Chip label={section.label} size="small" sx={{ mb: 1, borderRadius: 1, color: 'white', bgcolor: 'rgba(255,255,255,.12)' }} />
                                <Typography variant="h4" color="inherit">{section.title}</Typography>
                                <Typography sx={{ color: 'rgba(255,255,255,.68)', mt: .5 }}>{section.text}</Typography></Box>
                        </Stack>
                    </Paper>}
                    <Box sx={section ? { '& .MuiTypography-h4:first-of-type': { display: 'none' },
                        '& > .MuiContainer-root, & > .MuiBox-root': { px: '0 !important' } } : undefined}>
                    <Routes>
                        <Route path="/blog" element={<BlogComponent />} />
                        <Route path="/products" element={<ProductComponent />} />
                        <Route path="/passport" element={<PassportComponent />} />
                        <Route path="/docs" element={<DocumentsComponent />} />
                        <Route path="/promo" element={<PromoComponent />} />
                        <Route path="/docs-gen" element={<GenerateDocumentComponent />} />
                        <Route path="/" element={<OrderComponent />} />
                    </Routes>
                    </Box>
                </ContentWrapper>
            </Box>
        </Box>
    )
}

export default PanelPage;
